import React, { Component } from 'react';

import NavBar from '../navBar/NavBar';
import AnnouncementBanner from '../common/announcementBanner/AnnouncementBanner';
import Footer from '../footer/Footer';
import LandingSection from './landing/Landing';
import CoreResearchAreasSection from './coreResearchAreas/CoreResearchAreas';
import ProjectsShowcaseSection from './projectsShowcase/ProjectsShowcase';
import IndustrySection from './industry/Industry';
import PartnersSection from './partners/Partners';
import ScrollToTopOnMount from '../ScrollToTop';

import './Home.css';

import { trackPage } from '../helpers/AnalyticsManager';


class Home extends Component {
  constructor() {
    super();

    trackPage('Home');
  }

  render() {
    return (
      <div className="Home">
        <ScrollToTopOnMount />
        <NavBar />
        <AnnouncementBanner
          text="As inscrições para o Reality Hack estão abertas!"
          buttonTitle="Inscreva&#8209;se!"
          buttonLink="http://voxarlabs.cin.ufpe.br/realityhack"
        />
        <LandingSection />
        <CoreResearchAreasSection />
        <ProjectsShowcaseSection />

        <IndustrySection />
        <PartnersSection />
        <Footer target="industry" language="english" whiteMode />
      </div>
    );
  }
}

export default Home;
